import { useCallback } from 'react';
import { USER_ID } from 'src/common/const';
import { request } from 'src/common/request';
import { updateCurrentUser } from 'src/services/user/current-user';
import { setLocalStorage } from 'src/utils/local-storage';

export const useFetchSharePageUser = () => {
  // 这个 hooks 是为了避免调用 useFetchUser 时 token 过期时返回 401, 导致分享页跳转至登录页
  return useCallback(async () => {
    const useId = localStorage.getItem(USER_ID);
    if (useId) {
      const res = await request.infra.getSharePageUser(useId);
      // token 过期的时候返回 {}
      if (!res.uuid) return;
      updateCurrentUser(res);
      setLocalStorage(USER_ID, res.uuid);
      return res;
    }
  }, []);
};
